// extracted by mini-css-extract-plugin
export default {"title":"SessionForm_title__tcfNc","border":"SessionForm_border__E92Tg"};